export default __webpack_public_path__ + "static/media/profileCard.1057ef48.png";